export default __webpack_public_path__ + "static/sc-maps-e00529c368e8331f8582a30eaa717345.webp";